import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  Table,
  Button,
  I18n,
} from 'components';

import {
  formatPhone,
  formatPrice,
  formatDateString,
} from 'utils/formatString';

import PaymentsDetailsTable from '../../components/PaymentsDetailsTable';
import { fetchPayments } from '../../actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class Payments extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showAll: false,
    };
  }

  componentDidMount() {
    this.props.actions.fetchPayments();
  }

  showAll = () => {
    this.setState({ showAll: true });
  };

  renderPaymentsDetailsTable = ({ paymentDivisions, overpaymentValue }) => this.props.postpaid && paymentDivisions && (
  <PaymentsDetailsTable
    data={paymentDivisions}
    overpayment={overpaymentValue}
  />
  );

  render() {
    const {
      list,
      actions,
      postpaid,
      toggleDetailsRow,
      isEmpty,
      isFetching,
    } = this.props;

    const { showAll } = this.state;

    if (isEmpty) {
      return null;
    }

    return (
      <DataBlocks.Block
        title={<I18n path="detalization.payments.blockTitle" />}
        refreshAction={actions.fetchPayments}
        isLoading={isFetching}
      >
        {list && list.length ? (
          <>
            <Table
              expandRenderer={this.renderPaymentsDetailsTable}
              toggleExpandableRow={toggleDetailsRow}
              data={showAll || list.length <= 7 ? list : list.slice(0, 5)}
              config={{
                columns: [
                  {
                    name: 'detalization.payments.paymentDate',
                    dataField: 'date',
                    transformer: (row) => formatDateString(row.date, 'DD.MM.YYYY'),
                    expandable: postpaid,
                  },
                  {
                    name: 'detalization.payments.channel',
                    dataField: 'channel',
                  },
                  {
                    name: 'detalization.payments.phoneNumber',
                    dataField: 'ctn',
                    transformer: (row) => formatPhone(row.ctn),
                    hideOnMobile: true,
                  },
                  {
                    name: postpaid
                      ? 'detalization.payments.paymentSumWithVat'
                      : 'detalization.payments.paymentSum',
                    dataField: 'value',
                    transformer: (row) => `${formatPrice(row.value)} ₽`,
                    width: '80px',
                  },
                  {
                    name: 'detalization.payments.statusText',
                    dataField: 'statusText',
                    hideOnMobile: true,
                    width: '150px',
                  },
                ],
                uniqueIdField: 'id',
                expandField: 'expanded',
              }}
            />

            {!showAll && list.length > 7 && (
              <div className={cx('button')}>
                <Button onClick={this.showAll}>
                  <I18n path="detalization.payments.showAll" />
                </Button>
              </div>
            )}
          </>
        ) : (
          <div className={cx('emptyMessage')}>
            <I18n path="detalization.payments.emptyMessage" />
          </div>
        )}
      </DataBlocks.Block>
    );
  }
}

function mapStateToProps(state) {
  return state.detalization.payments;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchPayments }, dispatch),
  };
}

Payments.propTypes = {
  list: PropTypes.array,
  actions: PropTypes.object,
  postpaid: PropTypes.bool,
  toggleDetailsRow: PropTypes.func,
  isEmpty: PropTypes.bool,
  isFetching: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
